export const QUERY_KEYS = {
  USER_CREDIT_HISTORY: {
    LIST: ['user-credit-history', 'list'],
  },
  NOTIFICATIONS: {
    LIST: ['new-notifications', 'list'],
    HISTORY: ['new-notifications', 'history'],
    STATUS: ['new-notifications', 'status'],
  },
  YOUTUBE: {
    LIVE_STREAM_VIDEOS: ['youtube', 'live-stream-videos'],
  },
  APP_CONFIG: {
    HEADER_MENU: ['app-config', 'header-menu-links'],
    FOOTER: ['app-config', 'footer-config'],
    APPLICATION_CONFIG: ['app-config', 'application-config'],
    USER_TERMS_AND_CONDITIONS: ['app-config', 'user-terms-and-conditions'],
    MENU_TRANSLATIONS: ['app-config', 'menu-translations'],
  },
} as const;
